import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { memo as V, useMemo as c } from "react";
import { u as l } from "../../../styled-components.browser.esm-BFmoFexH.js";
import b from "../box/Box.js";
import { MdView as a, ValueDescription as v } from "@biron-data/react-components";
import { useFilterValue as D, isFilterEmpty as T } from "../box/utils.js";
import { useLanguageResolver as j } from "@biron-data/react-contexts";
const S = V(({
  filter: e,
  close: p,
  handleFilterChange: d,
  bordered: f,
  getPopupContainer: u,
  isEditable: m = !0,
  onEdit: g,
  loadDictionaryEntries: h
}) => {
  const i = j(), o = D(e, i), n = c(() => e.predicate.negate ? i.get("configuration-chart-filter-description.filterType.different") : i.get("configuration-chart-filter-description.filterType.equal"), [e.predicate.negate, i]), x = c(() => {
    let r = "";
    const y = i.get("configuration-chart-filter-description.header", {
      alias: e.reference.alias,
      description: e.reference.description
    });
    return T(e) ? r = i.get("configuration-chart-filter-description.details.empty", e.reference.alias) : r = i.get("configuration-chart-filter-description.details.filled", {
      filterType: n,
      filterValue: o
    }), /* @__PURE__ */ s(M, { children: [
      /* @__PURE__ */ t(a, { description: y }),
      /* @__PURE__ */ t("br", {}),
      /* @__PURE__ */ t(a, { description: r })
    ] });
  }, [e, n, o, i]);
  return /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ t(
      b,
      {
        filter: e,
        close: p,
        handleFilterChange: d,
        isResumable: !1,
        isEditable: m,
        bordered: f,
        getPopupContainer: u,
        onEdit: g,
        loadDictionaryEntries: h
      }
    ),
    /* @__PURE__ */ t(w, { children: /* @__PURE__ */ t(v, { children: x }) })
  ] });
}), w = l.div`
  position: absolute;
  right: -24px;
  top: 0;
  height: 100%;
  width: 19px;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`, M = l.div`
  strong {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
  }
  `;
export {
  S as default
};
//# sourceMappingURL=BoxWithDescription.js.map
